import _ from 'lodash';
import React from 'react';

interface UseImagesLoadingObserverArg {
  container?: React.MutableRefObject<HTMLElement>;
  onLoaded(): void;
  timeout?: number;
}

// TODO: use it everywhere instead of 'react-on-images-loaded' library
export const useImagesLoadingObserver = (arg: UseImagesLoadingObserverArg) => {
  const { onLoaded, timeout = 15000 } = arg;

  const imagesLoaded = React.useRef<boolean>(false);
  const isMounted = React.useRef<boolean>(true);
  const ownContainerRef = React.useRef<HTMLElement>(null);
  const container = arg.container ?? ownContainerRef;

  const [imagesCount, setImagesCount] = React.useState(0);
  const [loadedImagesCount, setLoadedImagesCount] = React.useState(0);

  const onTimeout = (): void => {
    if (!imagesLoaded.current && isMounted.current) {
      onLoaded();
    }
  };
  const onImageLoad = (): void => {
    if (isMounted.current) {
      setLoadedImagesCount(count => count + 1);
    }
  };

  React.useEffect(
    () => {
      const images = container.current?.getElementsByTagName('img');

      if (!images) {
        return;
      }
      setImagesCount(images.length);
      let timerId: number;

      if (images.length !== 0) {
        timerId = window.setTimeout(onTimeout, timeout);
      } else {
        onLoaded();
      }

      _.forEach(images, image => image.addEventListener('load', onImageLoad));

      return (): void => {
        isMounted.current = false;
        _.forEach(images, imgElement => imgElement.removeEventListener('load', onImageLoad));
        if (timerId) {
          clearTimeout(timerId);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  React.useEffect(
    () => {
      if (imagesCount > 0 && loadedImagesCount >= imagesCount && isMounted.current) {
        imagesLoaded.current = true;
        onLoaded();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loadedImagesCount, imagesCount],
  );

  return {
    container,
  };
};
